module.exports = __webpack_public_path__ + "static/media/Reportdefault2.44e6e958.png";